var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[(_vm.$route.query.account === 'doctorplan')?_c('Loading',{attrs:{"text":"Loading article..."}}):_c('GenericLoading',{attrs:{"text":"Loading article..."}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }